/**
 * ハコツル LP 共通: zoom 補正 / sp-scale ユーティリティ。
 *
 * top-about-crane.js と top-about-pin.js に重複していた getEffectiveZoom と、
 * top-about-crane.js が CSS の --sp-scale を JS 側で再実装していた getSpScale を
 * ここに集約する。 window.HakotsuruZoom として公開し、 利用スクリプトより前に
 * defer 読み込みする (layout/theme.liquid)。
 */
(function () {
  'use strict';

  /* 祖先要素に適用された zoom を累積取得する。
     PC 中間サイズ (tailwind.css の @media 60-76.25rem で #top-fv-section / #about /
     footer に zoom) では getBoundingClientRect が描画値 (zoom 適用後) を返すため、
     祖先の zoom を累積し逆数で layout 値に揃える用途。 */
  function getEffectiveZoom(el) {
    var zoom = 1;
    var p = el;
    while (p && p !== document.documentElement) {
      var z = parseFloat(getComputedStyle(p).zoom);
      if (z && z !== 1) zoom *= z;
      p = p.parentElement;
    }
    return zoom;
  }

  /* 要素の layout 上の絶対 Y 座標 (zoom 補正済み、 window.scrollY と同じ単位)。 */
  function getPageY(el) {
    return el.getBoundingClientRect().top / getEffectiveZoom(el) + window.scrollY;
  }

  /* assets/tailwind.css:33 の
       --sp-scale: clamp(1, calc(100vw / 375px), calc(600 / 375))
     と同じ値を返す。 getComputedStyle().getPropertyValue('--sp-scale') は clamp(...)
     式を文字列のまま返し評価値が取れないため JS で再現する。
     - viewport >= 960 (md:): 1 (CSS の @media 60rem で 1 にリセット)
     - viewport 375-600: 100vw / 375
     - viewport 600 以上 (< 960): 1.6 (= 600/375、 clamp 上限)
     閾値 (375 / 600 / 960) を変更するときは CSS 側 (tailwind.css:33, 40-42) と
     本関数を必ず同時に直すこと。 */
  function getSpScale() {
    var vw = window.innerWidth;
    if (vw >= 960) return 1;
    return Math.max(1, Math.min(vw / 375, 600 / 375));
  }

  window.HakotsuruZoom = {
    getEffectiveZoom: getEffectiveZoom,
    getPageY: getPageY,
    getSpScale: getSpScale
  };
})();
